import { render, staticRenderFns } from "./PageTwoElite.vue?vue&type=template&id=507a194c&scoped=true"
import script from "./PageTwoElite.vue?vue&type=script&lang=js"
export * from "./PageTwoElite.vue?vue&type=script&lang=js"
import style0 from "./PageTwoElite.vue?vue&type=style&index=0&id=507a194c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a194c",
  null
  
)

export default component.exports